<template>
  <draggable
    class="draggable"
    tag="ul"
    v-if="list"
    :list="list"
    :group="{ name: 'g1' }"
    ghost-class="ghost"
    @change="change"
    @end="changeMove"
  >
    <li v-for="menu in list" :key="menu.name" class="li-menu-drag mb-3"  :id="'id-menu' + menu.id">
      <button
        class="btn btn-link prova nopadding"
        type="button"
        @click="setPage(true, menu.id, menu.idMenu, menu.menuType)"
      >
        <i :class="menu.cssIcon ? 'nav-icon fa ' + menu.cssIcon : 'nav-icon fa fa-file-text-o'" data-toggle="tooltip" data-placement="right" :data-original-title="menu.title" v-if="menu.menuType !='Link'"></i>
        <i :class="'nav-icon fa fa-link'" data-toggle="tooltip" data-placement="right" :data-original-title="menu.title" v-else></i>
        <span style="padding:1">&nbsp;{{ menu.title }}</span>
      </button>
      <div class="div-cont-rapid-icon">
        <span v-if="!menu.blocked" @click="deleteMenu(menu.id)">
          <i class="fa fa-trash icon-eye-menu icon-trash-menu" title="Elimina questa pagina"></i>
        </span>
        <span @click="cloneMenu(menu.id)">
          <i class="fa fa-files-o icon-eye-menu icon-trash-menu" title="Duplica questa pagina"></i>
        </span>
        <span v-if="menu.online" @click="updateOnlinePage(false, menu.id)">
          <i class="fa fa-eye icon-eye-menu icon-eye-menu-online" title="Clicca per offline"></i>
        </span>
        <span v-else @click="updateOnlinePage(true, menu.id)">
          <i class="fa fa-eye-slash icon-eye-menu icon-eye-menu-offline" title="Clicca per online"></i>
        </span>
      </div>
      <menu-draggable :list="menu.subMenu" ghost-class="ghost" @change="change" @end="changeMove" />
    </li>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "menu-draggable",
  props: {
    list: {
      required: true,
      type: Array
    }
  },
  components:{
    draggable
  },
  methods: {
    setPage(isMenuWeb, id, idMenu, menuType) {
      try {
        this.$parent.setPage(isMenuWeb, id, idMenu, menuType);
      } catch {
        this.$parent.$parent.setPage(isMenuWeb, id, idMenu, menuType);
      }

      $(".li-menu-drag").removeClass("activeMenu");
      $("#id-menu" + id).addClass("activeMenu");
    },
    changeMove(event) {
      console.log('passo in changeMove');
      var menuDraggable = this;
      /*if (event.to.__vue__ != null) {
        spinnerHelpers.show();
        pageServices.postMenuList(event.to.__vue__.list, function() {
          spinnerHelpers.hide();
        });
      }*/
      menuDraggable.change(event);
    },
    change(event) {
      console.log('passo in change');
      var menuDraggable = this;
      if (functionHelpers.isValued(event.moved) || functionHelpers.isValued(event.removed)) {
        spinnerHelpers.show();
        if(functionHelpers.isValued(menuDraggable.$parent.$parent.$parent.$parent.list)){
          pageServices.postMenuList(menuDraggable.$parent.$parent.$parent.$parent.list, function() {
            spinnerHelpers.hide();
          });
        }else{
          if(functionHelpers.isValued(menuDraggable.$parent.$parent.$parent.list)){
            pageServices.postMenuList(menuDraggable.$parent.$parent.$parent.list, function() {
              spinnerHelpers.hide();
            });
          }else{
            if(functionHelpers.isValued(menuDraggable.$parent.$parent.list)){
              pageServices.postMenuList(menuDraggable.$parent.$parent.list, function() {
                spinnerHelpers.hide();
              });
            }else{
              if(functionHelpers.isValued(menuDraggable.$parent.list)){
                pageServices.postMenuList(menuDraggable.$parent.list, function() {
                  spinnerHelpers.hide();
                });
              }else{
                if(functionHelpers.isValued(menuDraggable.list)){
                  pageServices.postMenuList(menuDraggable.list, function() {
                    spinnerHelpers.hide();
                  });
                }
              }
            }
          }
        }

        /*pageServices.postMenuList(menuDraggable.list, function() {
          spinnerHelpers.hide();
        });*/
      }
    },
    updateOnlinePage(valueOnline, id) {
      var menuDraggable = this;
      spinnerHelpers.show();
      if (valueOnline === null) {
        valueOnline = true;
      }
      pageServices.postOnlinePage(valueOnline, id, function() {
        menuDraggable.$parent.refreshList();
        spinnerHelpers.hide();
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("UpdateCompleted")
        );
      });
    },

    cloneMenu(id) {
      var menuDraggable = this;
      spinnerHelpers.show();
      pageServices.clone(id, function() {
        //menuDraggable.$parent.refreshList();

        if(functionHelpers.isValued(menuDraggable.$parent.$parent.$parent.$parent.list)){
          menuDraggable.$parent.$parent.$parent.$parent.$parent.refreshList();
        }else{
          if(functionHelpers.isValued(menuDraggable.$parent.$parent.$parent.list)){
            menuDraggable.$parent.$parent.$parent.$parent.refreshList();
          }else{
            if(functionHelpers.isValued(menuDraggable.$parent.$parent.list)){
              menuDraggable.$parent.$parent.$parent.refreshList();
            }else{
              if(functionHelpers.isValued(menuDraggable.$parent.list)){
                menuDraggable.$parent.$parent.refreshList();
              }
            }
          }
        }

        spinnerHelpers.hide();
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("CloneCompleted")
        );
      });
    },


    deleteMenu(id) {
      var menuDraggable = this;
      if (confirm("Vuoi eliminare la pagina?")) {
      spinnerHelpers.show();
      pageServices.del(id, function() {

        if(functionHelpers.isValued(menuDraggable.$parent.$parent.$parent.$parent.list)){
          menuDraggable.$parent.$parent.$parent.$parent.$parent.refreshList();
        }else{
          if(functionHelpers.isValued(menuDraggable.$parent.$parent.$parent.list)){
            menuDraggable.$parent.$parent.$parent.$parent.refreshList();
          }else{
            if(functionHelpers.isValued(menuDraggable.$parent.$parent.list)){
              menuDraggable.$parent.$parent.$parent.refreshList();
            }else{
              if(functionHelpers.isValued(menuDraggable.$parent.list)){
                menuDraggable.$parent.$parent.refreshList();
              }
            }
          }
        }

        spinnerHelpers.hide();
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
      });
    }
    }
  }
};
</script>
<style scoped>

.card {
  border: 0px;
}
.draggable {
  padding: 10px 0;
  cursor: grabbing;
  padding-bottom: 20px;
}
.li-menu-drag {
    position: relative;
    border: 1px solid #ededed;
    min-height: 50px;
    margin-top: 4px;
    border-radius: 4px 15px 4px 4px;
    padding-left: 4px;
    background:#fff;
    box-shadow: #ccc 0px 4px 10px;
    animation:.3s all
}
.li-menu-drag:hover {
  background: #F7F7F7;
  box-shadow: #d7d7d7 0 4px 10px;
} 
.li-menu-drag li {
  margin-right: 10px;
}
.draggable .sortable-chosen {
  transform: rotate(-5deg) !important
}
.div-cont-rapid-icon {
    position: absolute;
    right: 0;
    bottom: 5px;
    z-index: 0;
    padding: 0px 0px 0px 5px;
}
.btn-link {
    display: inline-flex;
    overflow: hidden;
    white-space: nowrap;
    color: #666;
}
.nav-icon {
    margin-top: 3px;
}
button span {
    padding: 0 .25rem 0 .2rem;
}
.fa-copy:before, .fa-files-o:before {
    color: #666;
    font-size: 13px;
}
.fa-trash:before {
  color: #bf395f;
}
.li-menu-drag:active {
    background: #e4ecf1;
}
.activeMenu{
    background: #e4ecf1;
}

</style>